import React, { useCallback, useMemo, useState } from 'react'
import { MenuUnfoldOutlined } from '@ant-design/icons'
import { Button, Modal, Space, Tree } from 'antd'
import { get, isEmpty, noop } from 'lodash'
import PropTypes from 'prop-types'

import { ListItemTreeSelect } from '../../../common/components/sections'
import { StyledAlert } from '../../../common/components/styled'
import {
  COMPONENT_INGREDIENT_TYPES,
  INGREDIENT_TREE_FIELD_MIN_HEIGHT,
} from '../../../common/constants'
import { antFormItemNamePropType } from '../../../common/prop-types'

import { getComponentIngredientsTreeForId } from '../../helpers'

const IngredientComponentIngredientFormListItem = ({
  shouldModify,
  name,
  treeData,
  onClear,
  value,
  onChange,
  flattenedIngredientOptionsGroupedById,
  ...rest
}) => {
  const [
    isComponentComponentModalVisible,
    setIsComponentComponentModalVisible,
  ] = useState(false)

  const valueNamePath = useMemo(
    () => get(flattenedIngredientOptionsGroupedById, `${value}[0].namePath`),
    [flattenedIngredientOptionsGroupedById, value],
  )

  const componentIngredientsOfValue = useMemo(
    () =>
      getComponentIngredientsTreeForId(
        value,
        flattenedIngredientOptionsGroupedById,
      ),
    [flattenedIngredientOptionsGroupedById, value],
  )

  const titleRender = useCallback(
    node => (
      <StyledAlert
        banner
        showIcon={false}
        message={node.title}
        type={
          node.type === COMPONENT_INGREDIENT_TYPES.DEFINITE ? 'info' : 'warning'
        }
      />
    ),
    [],
  )

  const showModal = useCallback(
    () => setIsComponentComponentModalVisible(true),
    [],
  )

  const hideModal = useCallback(
    () => setIsComponentComponentModalVisible(false),
    [],
  )

  return (
    <Space>
      <ListItemTreeSelect
        shouldModify={shouldModify}
        name={name}
        treeData={treeData}
        onClear={onClear}
        value={value}
        onChange={onChange}
        {...rest}
      />
      {!isEmpty(componentIngredientsOfValue) && (
        <>
          <Button
            shape="circle"
            icon={<MenuUnfoldOutlined />}
            size="small"
            onClick={showModal}
          />
          <Modal
            visible={isComponentComponentModalVisible}
            title={`Component ingredients for ${valueNamePath}`}
            footer={null}
            onCancel={hideModal}
          >
            <Tree
              treeData={componentIngredientsOfValue}
              titleRender={titleRender}
              height={INGREDIENT_TREE_FIELD_MIN_HEIGHT}
            />
          </Modal>
        </>
      )}
    </Space>
  )
}

IngredientComponentIngredientFormListItem.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  shouldModify: PropTypes.func.isRequired,
  name: antFormItemNamePropType.isRequired,
  treeData: PropTypes.array.isRequired,
  onClear: PropTypes.func.isRequired,
  flattenedIngredientOptionsGroupedById: PropTypes.object,
}

IngredientComponentIngredientFormListItem.defaultProps = {
  value: undefined,
  onChange: noop,
  flattenedIngredientOptionsGroupedById: {},
}

export default IngredientComponentIngredientFormListItem
